/** @jsx jsx */

import { useState } from 'react';

import { css, jsx } from '@emotion/core';

import Link from 'app/common/components/Link';

import ImageDropzone from './ImageDropzone';

const Styles = {
  root: css`
    display: flex;
    align-items: center;
  `,
  image: css`
    max-width: 64px;
    max-height: 64px;
    border-radius: 3px;
  `,
  imageWrapper: css`
    margin-left: 10px;
    margin-right: 10px;
  `,
};

type Props = {
  imageUrl: string;
  isReadOnly: boolean;
  onChange: (imageFile: File) => void;
};

function ImageField({ imageUrl, isReadOnly, onChange }: Props) {
  const [previewObjectURL, setPreviewObjectURL] = useState<string>();
  const url = previewObjectURL || imageUrl;

  return (
    <div css={Styles.root}>
      {url && (
        <div css={Styles.imageWrapper}>
          <Link href={url} target="_blank">
            <img alt="App Logo" css={Styles.image} src={url} />
          </Link>
        </div>
      )}
      <ImageDropzone
        isReadOnly={isReadOnly}
        onDrop={files => {
          const imageFile = files[0];
          onChange(imageFile);
          setPreviewObjectURL(URL.createObjectURL(imageFile));
        }}
      />
    </div>
  );
}

export default ImageField;
